import { memo } from 'react';
import { Badge } from 'src/components/badge';
import { Colors } from 'src/styles';
import { labelsToOptions } from 'src/utils/labels-to-options';

export type DocumentStatus = 'WITHDRAWN' | 'PUBLISHED';

export const documentStatusLabels: { [key in DocumentStatus]: string } = {
  WITHDRAWN: 'Withdrawn',
  PUBLISHED: 'Published',
};

export const documentStatusOptions = labelsToOptions(documentStatusLabels);

type Props = { value: DocumentStatus };

export const ShipperDocumentStatus = memo<Props>(({ value }) => {
  switch (value) {
    case 'PUBLISHED':
      return <Badge color={Colors.success}>{value}</Badge>;
    case 'WITHDRAWN':
      return <Badge color={Colors.inactive}>{value}</Badge>;
  }
});
